<template>
    <fragment>
        <!-- Filters -->
        <filter-sidebar v-if="filters" v-bind:filters="filters"></filter-sidebar>
        <section class="section bg-white">
            <div class="global-container">
                <div class="row" v-if="listing.length > 0">
                    <div class="section-general-content col-md-9">
                        <intro-content></intro-content>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" v-if="listing.length > 0">
                        <ul class="person-info">
                            <!-- Person Summary Item -->
                            <template v-if="displaytype == ''">
                                <person-item v-bind:item="item" v-for="(item, index) in listing" v-bind:key="item.Url"></person-item>
                            </template>
                            <template v-if="displaytype == 'leadership'">
                                <person-item-leadership v-bind:item="item" v-for="(item, index) in listing" v-bind:key="item.URL"></person-item-leadership>
                            </template>
                            <template v-if="displaytype == 'research'">
                                <person-item-research v-bind:item="item" v-for="(item, index) in listing" v-bind:key="item.URL"></person-item-research>
                            </template>
                            <template v-if="displaytype == 'smerp'">
                                <person-item-smerp v-bind:item="item" v-for="(item, index) in listing" v-bind:key="item.URL"></person-item-smerp>
                            </template>
                        </ul>
                        <section class="section bg-white" v-if="listing.length > 0 && pagination.totalPages > 1">
                            <div class="row">
                                <div class="col-md-12">
                                    <pagination></pagination>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="col-md-12 align-center" v-if="listing.length === 0">
                        <h2 class="not-found-heading">Sorry, no items were found matching your specifications.</h2>
                        <p>
                            Try removing some filters or searching a different term.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </fragment>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import Pagination from '../components/listing/pagination-dropdown';
    import PersonItem from '../components/listing/person-item';
    import PersonItemLeadership from '../components/listing/person-item-leadership';
    import PersonItemResearch from '../components/listing/person-item-research';
    import PersonItemSmerp from '../components/listing/person-item-smerp';
    import FilterSidebar from '../components/listing/filter-sidebar';
    import researchFilter from '../filters/person-research-filter';
    import typeStateSearchFilter from '../filters/person-typestatesearch-filter';
    import typeStateFilter from '../filters/person-typestate-filter';
    import typeSearchFilter from '../filters/person-typesearch-filter';
    import stateSearchFilter from '../filters/person-statesearch-filter';
    import typeFilter from '../filters/person-type-filter';
    import stateFilter from '../filters/person-state-filter';
    import searchFilter from '../filters/person-search-filter';
    import * as CONST from '../utils/constants';
    import IntroContent from '../components/layout/intro-content';

    export default {
        props: ['filterid', 'filtertype', 'displaytype', 'result', 'resource'],
        data: function () {
            return {
                filters: null,
            }
        },
        computed: mapState({
            loading: state => state.listing.loading,
            listing: state => state.listing.listing,
            pagination: state => state.listing.pagination,
        }),
        components: {
            pagination: Pagination,
            'person-item': PersonItem,
            'person-item-leadership': PersonItemLeadership,
            'person-item-research': PersonItemResearch,
            'person-item-smerp': PersonItemSmerp,
            'filter-sidebar': FilterSidebar,
            'intro-content': IntroContent,
        },
        watch: {},
        mounted: function () {
            console.log(this.result);
            let _this = this;

            // take props and send to vuex store
            this.setInitData(this.result);
            this.setResource(this.resource);

            if (this.filtertype == "research") {
                this.filters = researchFilter;
            } else if (this.filtertype == "person-state-search") {
                this.filters = typeStateSearchFilter;
            } else if (this.filtertype == "person-state") {
                this.filters = typeStateFilter;
            } else if (this.filtertype == "person-search") {
                this.filters = typeSearchFilter;
            } else if (this.filtertype == "state-search") {
                this.filters = stateSearchFilter;
            } else if (this.filtertype == "person") {
                this.filters = typeFilter;
            } else if (this.filtertype == "state") {
                this.filters = stateFilter;
            } else if (this.filtertype == "search") {
                this.filters = searchFilter;
            }

            this.$store.subscribeAction((action, state) => {
                if (action.type === 'listing/setFilter') {
                    $('html, body').animate({
                        scrollTop: $('.person-listing').offset().top
                    }, 1000);
                }
            })

            // if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/updateSpecification') {
                    this.setFilter();
                }
            });
        },
        methods: {
            ...mapActions('listing', { setFilter: 'setFilter' }),
            ...mapMutations('listing', { setInitData: 'setInitData' }),
            ...mapMutations('listing', { setResource: 'setResource' }),
        },
    }
</script>